<template>

    <dialog-template :header="$t('contact-form.availability_query')" @closeDialog="emit('closeDialog')">
        <v-form
            @submit.prevent="submit"
        >
                <v-defaults-provider
                    :defaults="{
                        VTextField: {
                            variant: 'outlined',
                            density: 'comfortable',
                            class: 'text-grey-darken-1 font-weight-light text-body-2',
                        },
                        VTextarea: {
                            variant: 'outlined',
                            density: 'comfortable',
                            class: 'text-grey-darken-1 font-weight-light text-body-2',
                        },
                    }"
                >
                    <motonet-full-width-input
                        :label="$t('contact-form.your_name')"
                        required
                        v-bind:input-cols="inputCols"
                    >
                        <template v-slot:input="{id}">
                            <v-text-field
                                :id="id"
                                v-model="form.name"
                                autocomplete="name"
                                @change="form.validate('name')"
                                :error="form.invalid('name')"
                                :error-messages="form.errors['name']"
                                maxlength="50"
                            ></v-text-field>
                        </template>
                    </motonet-full-width-input>
                    <motonet-full-width-input
                        :label="$t('contact-form.your_email')"
                        required
                        v-bind:input-cols="inputCols"
                    >
                        <template v-slot:input="{id}">
                            <v-text-field
                                :id="id"
                                v-model="form.email"
                                autocomplete="email"
                                @change="form.validate('email')"
                                :error="form.invalid('email')"
                                :error-messages="form.errors['email']"
                                maxlength="50"
                            ></v-text-field>
                        </template>
                    </motonet-full-width-input>
                    <motonet-full-width-input
                        :label="$t('contact-form.your_phone')"
                        v-bind:input-cols="inputCols"
                    >
                        <template v-slot:input="{id}">
                            <v-text-field
                                :id="id"
                                type="tel"
                                v-model="form.telephone"
                                autocomplete="tel"
                                @change="form.validate('telephone')"
                                :error="form.invalid('telephone')"
                                :error-messages="form.errors['telephone']"
                                maxlength="20"
                            ></v-text-field>
                        </template>
                    </motonet-full-width-input>
                    <motonet-full-width-input
                        :label="$t('contact-form.your_query')"
                        required
                        no-margin-label
                        v-bind:input-cols="inputCols"
                    >
                        <template v-slot:input="{id}">
                            <v-textarea
                                :id="id"
                                v-model="form.text"
                                @change="form.validate('text')"
                                :error="form.invalid('text')"
                                :error-messages="form.errors['text']"
                                maxlength="1500"
                            ></v-textarea>
                        </template>
                    </motonet-full-width-input>
                    <v-row no-gutters="">
                        <v-col cols="12" md="6" offset-md="6" offset-lg="4" lg="8">
                            <div class="mb-5 text-center text-grey font-weight-light">
                                {{ $t('contact-form.personal_1') }} <a class="text-decoration-underline text-grey"
                                                                       :href="route('gdpr')"
                                                                       target="_blank">{{ $t('contact-form.personal_2') }}</a>
                            </div>
                            <v-btn
                                color="orange"
                                block
                                elevation="0"
                                :disabled="form.processing"
                                :loading="form.processing"
                                class="text-white text-body-2 font-weight-bold"
                                @click="submit"
                                size="48"
                            >
                                {{ $t('contact-form.send_short') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-defaults-provider>
        </v-form>
    </dialog-template>
</template>

<script setup>
import {inject, computed, watch, markRaw} from "vue";
import {usePage} from "@inertiajs/vue3";
import MotonetFullWidthInput from "../../../../frontend/motonet/components/MotonetFullWidthInput.vue";
import {useForm} from "laravel-precognition-vue-inertia";
import DialogTemplate from "./DialogTemplate.vue";

const props = defineProps({
    id: {
        type: [String, Number],
        required: true
    }
})

const user = computed(() => usePage().props.customer)
const emit = defineEmits(['closeDialog']);
const route = inject('route');

const inputCols = markRaw({
    cols: 12,
    md: 6,
    lg: 8
})

const form = useForm('post', route('product.sendAvailability'), {
    name: '',
    email: '',
    telephone: '',
    text: '',
    id: props.id
});

watch(user, (val) => {
    if (val.name) {
        form.name = val.name;
    }

    if (val.email) {
        form.email = val.email;
    }

    if (val.telephone) {
        form.telephone = val.telephone;
    }
}, {immediate: true})
const submit = () => {
    form.submit({
        errorBag: 'productAvailability',
        onSuccess: () => {
            emit('closeDialog')
        }
    });
};
</script>

<style scoped lang="scss">
.v-input {
    + .v-input {
        margin-top: .3em;
    }
}
</style>
